/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary (base 2)`)
};

const es_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario (base 2)`)
};

const de_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binär (Basis 2)`)
};

const nl_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binair (basis 2)`)
};

const fr_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaire (base 2)`)
};

const it_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario (base 2)`)
};

const pt_br2_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário (base 2)`)
};

const pt_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário (base 2)`)
};

const ja_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二進法（基数 2）`)
};

const zh_nb_base2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二进制（2 进制）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_base2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_base2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_base2", locale)
	if (locale === "en") return en_nb_base2(inputs)
	if (locale === "es") return es_nb_base2(inputs)
	if (locale === "de") return de_nb_base2(inputs)
	if (locale === "nl") return nl_nb_base2(inputs)
	if (locale === "fr") return fr_nb_base2(inputs)
	if (locale === "it") return it_nb_base2(inputs)
	if (locale === "pt-BR") return pt_br2_nb_base2(inputs)
	if (locale === "pt") return pt_nb_base2(inputs)
	if (locale === "ja") return ja_nb_base2(inputs)
	return zh_nb_base2(inputs)
};